import Arrow from 'public/assets/arrows/right.svg'
import Logo from 'public/assets/logos/logo.svg'
import LogoWordmark from 'public/assets/logos/logo-wordmark.svg'

import css from './Breadcrumb.module.css'

export function Breadcrumb({ title, url }: { title: string; url: string }) {
    return (
        <div className={css.container}>
            <a href="/">
                <div className={css.logosContainer}>
                    <LogoWordmark className={css.logoWordmark} />
                    <Logo className={css.logo} />
                </div>
            </a>

            <div className={css.breadcrumbContainer}>
                <Arrow className={css.arrow} />
                <a href="/remote-work-guides">Remote Work Guides</a>
                <Arrow className={css.arrow} />
                <a href={url}>{title}</a>
            </div>
        </div>
    )
}
